import SoldTicketSaga from './sagas/SoldTicketSaga';
export default [
    SoldTicketSaga,
];